import {Grid} from 'quickstart/components/layout/Grid'
import {
  SIDENAV_COLUMN_GAP,
  SideNavContent,
} from 'quickstart/components/layout/SideNav/styles'
import styled, {
  SystemProps,
  breakpoints,
  css,
  system,
} from 'quickstart/styled-components/system'

export const BrowseGalleryGrid = styled(Grid)<SystemProps>`
  gap: ${SIDENAV_COLUMN_GAP};
  ${breakpoints({
    xs: {'grid-template-columns': 'minmax(0, 1fr)'},
    md: {'grid-template-columns': 'repeat(3, minmax(0, 1fr))'},
    lg: css`
      ${SideNavContent} & {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    `,
  })};
  ${system};
`
